/**************************************************
 * Nombre:       Tarjeta_Sostenibilidad
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Button, Grid, Typography} from "@mui/material";
import {theme} from "../../Tema";
import {useNavigate} from "react-router-dom";
import {formatoFecha} from "../../Utilidades/formatoFecha";


const Tarjeta_Sostenibilidad = ({item}) => {
    const navigate = useNavigate()

    return (
        <Grid
            container
            justifyContent={'flex-start'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}
            spacing={4}
        >


            <Grid container size={{xs: 12, sm: 5, md: 5}} sx={{justifyContent: 'flex-start'}}>
                <img src={item.img} width={'100%'} height={'auto'} style={{borderRadius: 10}}/>
            </Grid>

            <Grid container size={{xs: 12, sm: 7, md: 7}} sx={{justifyContent: 'flex-start'}}>
                <Grid
                    container
                    justifyContent={'flex-start'}
                    alignItems={'flex-start'}
                    size={{xs: 12, sm: 12, md: 12}}
                    spacing={1}
                >

                    <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                        <Typography sx={{color: theme.palette.primary.main, fontSize: 15, fontWeight: 600}}>
                            {formatoFecha(item.fecha)}
                        </Typography>
                    </Grid>

                    <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                        <Typography sx={{fontSize: 20, fontWeight: 600}}>{item.nombre}</Typography>
                    </Grid>

                    <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                        <Typography sx={{fontSize: 16, fontWeight: 400}}>
                            {item.descripcion}
                        </Typography>
                    </Grid>

                    <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: 2}}>
                        <Button
                            onClick={() => navigate('/Detalle_Sos/' + item.id)}
                            variant={'outlined'}>Ver Detalles</Button>
                    </Grid>

                </Grid>
            </Grid>

        </Grid>
    )

}
export default Tarjeta_Sostenibilidad